import { render } from "./TheMobile.vue?vue&type=template&id=c3be917c"
import script from "./TheMobile.vue?vue&type=script&lang=js"
export * from "./TheMobile.vue?vue&type=script&lang=js"

import "./TheMobile.vue?vue&type=style&index=0&id=c3be917c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__